import Animated, { SharedValue, useAnimatedStyle } from "react-native-reanimated";
import { Image } from "src/swsh-native";

const ImageCropperImageDisplay = ({
	uri,
	cropSV,
	inside,
}: {
	uri: string;
	cropSV: SharedValue<{
		x: number;
		y: number;
		scale: number;
	}>;
	inside: {
		width: number;
		height: number;
	};
}) => {
	const animatedStyle = useAnimatedStyle(
		() => ({
			transform: [
				{
					scale: cropSV.value.scale,
				},
				{ translateX: cropSV.value.x },
				{ translateY: cropSV.value.y },
			],
		}),
		[cropSV],
	);
	const size = Math.max(inside.width, inside.height);

	return (
		<Animated.View
			style={[
				{
					width: size,
					height: size,
					overflow: "hidden",
					justifyContent: "center",
					alignItems: "center",
				},
				animatedStyle,
			]}
		>
			<Image
				pointerEvents="none"
				alt="Image Cropper"
				src={uri}
				dim={{
					width: size,
					height: size,
				}}
				style={{
					position: "absolute",
				}}
				contentFit="contain"
				contentPosition="center"
			/>
		</Animated.View>
	);
};
export default ImageCropperImageDisplay;
